"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiCard = void 0;
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
var createMuiCard = function (theme) {
    var _a;
    return ({
        styleOverrides: {
            root: __assign((_a = { backgroundColor: colors_1.colors.White, boxShadow: "none", padding: global_1.spacing[4] }, _a[theme.breakpoints.up("sm")] = {
                padding: global_1.spacing[5],
            }, _a), global_1.card),
        },
    });
};
exports.createMuiCard = createMuiCard;
//# sourceMappingURL=card.js.map